import {
  CartItemInterface,
  ProductFieldsFragment,
} from 'graphql/generated/magentoApi';

export function itemsAreAllVirtual(items: CartItemInterface[]): boolean {
  return items.reduce<boolean>((isVirtual, item) => {
    const product = item.product as unknown as ProductFieldsFragment;
    return isVirtual && product.__typename === 'VirtualProduct';
  }, true);
}

export function containsVirtualItems(items: CartItemInterface[]): boolean {
  return !!items.find(
    item =>
      (item.product as unknown as ProductFieldsFragment).__typename ===
      'VirtualProduct',
  );
}

export function vendorsForItems(items: CartItemInterface[]): string[] {
  return items.reduce<string[]>((vendors, item) => {
    if (!vendors.includes(item.product.vendor_company)) {
      vendors.push(item.product.vendor_company);
    }
    return vendors;
  }, []);
}
